// faqData.js
const faqList = [
    {
      isActive: false,
      question: "What career options are available with a Geology degree?",
      answer:
        "Geology graduates have diverse career paths including  Mining geologist,Geotechnical engineer,Resource geologist, Geophysicist, Environmental geologist, Engineering geologist and Exploration geologist. Many graduates also pursue research roles in academia or join geological surveys. The field offers opportunities both in office-based analysis and field work in various environments worldwide."
    },
    {
      isActive: false,
      question: "What undergraduate research opportunities are available in the department?",
      answer:
        "CENG- Engineering in our Society"
    },
    {
      isActive: false,
      question: "How can I join the Geological Society student chapter?",
      answer:
        "Contact the Head of the Academic committee or the Head of Tratech committee"
    },
    {
      isActive: false,
      question: "What field courses are required for the major?",
      answer:
        "Quarry site visit - level 100. Amanchia community visit-level 200. Geological field mapping- level 200. Western traverse- level 300. Internship work- level 300"
    },
    {
      isActive: false,
      question: "Are internships available through the department?",
      answer:
        "Yes, our department actively maintains relationships with government agencies, environmental firms, and resource companies that regularly offer internships to our students. The department circulates internship opportunities through our mailing list and maintains a job board in the main building. Additionally, our annual Geology Career Fair brings potential employers to campus specifically seeking geology students for internships and entry-level positions."
    },
    {
      isActive: false,
      question: "What specializations or concentrations are offered within the Geology major?",
      answer:
        "Our department offers several concentrations including Environmental Geology, Petroleum Geology, Mining and Economic Geology, Hydrogeology, Geophysics, and Paleontology. Each concentration includes specialized coursework and often targeted research or field experiences. Students should consult with their academic advisor by sophomore year to plan appropriate course sequences for their chosen specialization."
    },
    {
      isActive: false,
      question: "How demanding is the fieldwork component of the program?",
      answer:
        "Fieldwork is a fundamental component of geological education and varies in physical demands. Most field trips require moderate hiking on uneven terrain in variable weather conditions. Field camps involve daily hiking, mapping exercises, and camping or dormitory living for extended periods. The department works to accommodate students with physical limitations while maintaining academic standards. We recommend discussing any concerns with the field course coordinator before enrollment."
    },
    {
      isActive: false,
      question: "What equipment do I need to purchase for my geology courses?",
      answer:
        "Basic geology, Geological field mapping, Mineralogy, Optical mineralogy, Soil mechanics, Hydrogeology, Geotechnical engineering"
    }
  ];
  
  export default faqList;